export enum RequirementStatus {
  Cancelled = "Cancelled",
  Pending = "Pending",
  InProgress = "In Progress",
  Submitted = "Submitted",
  Rejected = "Rejected",
  HasRejection = "Has Rejection",
  Approved = "Approved",
  Completed = "Completed",
}